/* Versioned OPS Pattern Project validation and restoration helpers. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) { root.OPS = root.OPS || {}; root.OPS.PatternProject = api; }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const VERSION = 1;
  const valid = (n, label) => { const v = Number(n); if (!Number.isFinite(v) || v <= 0) throw new RangeError(`${label} must be positive`); return v; };
  const finiteXY = item => { for (const key of ['xMm', 'yMm']) if (!Number.isFinite(Number(item[key]))) throw new Error(`Pattern tile element ${key} must be finite.`); };
  function validate(project, modes) {
    if (!project || project.schemaVersion !== VERSION) throw new Error('Unsupported Pattern Project schema version.');
    if (!project.projectId || typeof project.projectId !== 'string') throw new Error('Pattern Project needs a projectId.');
    if (!project.tile || !project.pattern || !Array.isArray(project.sourceArtwork) || !Array.isArray(project.tile.elements)) throw new Error('Pattern Project is missing tile, artwork or repeat settings.');
    valid(project.tile.widthMm, 'tile.widthMm'); valid(project.tile.heightMm, 'tile.heightMm');
    if (!modes.includes(project.pattern.mode)) throw new Error('Pattern Project uses an unsupported repeat mode.');
    const sources = new Set(project.sourceArtwork.map(asset => asset?.assetId).filter(Boolean));
    for (const item of project.tile.elements) {
      if (!item.id) throw new Error('Pattern tile element needs an id.');
      finiteXY(item); valid(item.widthMm, 'tile element widthMm'); valid(item.heightMm, 'tile element heightMm');
      if (item.type === 'shape') {
        if (!['rectangle', 'ellipse', 'triangle', 'tree', 'star', 'line'].includes(item.shapeType)) throw new Error('Pattern tile shape type is unsupported.');
        if (item.strokeWidthMm != null && (!Number.isFinite(Number(item.strokeWidthMm)) || Number(item.strokeWidthMm) < 0)) throw new RangeError('Shape outline width cannot be negative.');
      } else if (item.type === 'text') {
        if (typeof item.text !== 'string' || !item.text.trim()) throw new Error('Pattern tile text cannot be empty.');
        valid(item.fontSizeMm, 'text fontSizeMm');
        if (item.strokeWidthMm != null && (!Number.isFinite(Number(item.strokeWidthMm)) || Number(item.strokeWidthMm) < 0)) throw new RangeError('Text outline width cannot be negative.');
      } else if (!sources.has(item.assetId)) {
        throw new Error('Pattern tile element has no source artwork reference.');
      }
    }
    for (const key of ['gapXmm', 'gapYmm']) if (project.pattern[key] != null && (!Number.isFinite(Number(project.pattern[key])) || Number(project.pattern[key]) < 0)) throw new RangeError(`pattern.${key} cannot be negative.`);
    return true;
  }
  function restore(project, modes, profiles) {
    validate(project, modes);
    const saved = project.productOverrides?.activeSurface;
    const entry = Object.entries(profiles).find(([, profile]) => profile.id === saved?.profileId);
    const profileKey = entry?.[0] || 'gift-wrap';
    const profile = entry?.[1] || profiles[profileKey];
    return {
      projectId: project.projectId,
      createdAt: project.createdAt,
      mode: project.pattern.mode,
      tileW: Number(project.tile.widthMm),
      tileH: Number(project.tile.heightMm),
      background: project.tile.background || '#ffffff',
      gapX: Number(project.pattern.gapXmm) || 0,
      gapY: Number(project.pattern.gapYmm) || 0,
      offsetX: Number(project.pattern.offsetXmm) || 0,
      offsetY: Number(project.pattern.offsetYmm) || 0,
      elements: project.tile.elements.map(item => ({ ...item, scale: 1 })),
      profileKey,
      profile,
      surfaceHeight: Number(saved?.heightMm) || profile.heightMm
    };
  }
  return Object.freeze({ VERSION, validate, restore });
});
